// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilado propio del Centro de Aplicaciones.
   El lenguaje visual común (fuente, animaciones fg-*, capa de densidad) vive en
   \`src/ui/estilos.css\`, que se importa antes que este fichero desde index.jsx. */

* { margin: 0; padding: 0; box-sizing: border-box; }

input::placeholder { color: #9aa4af; }

/* En pantallas estrechas la barra superior se queda solo con el logotipo, los
   destinos y el botón de salir: el bloque de nombre y rol estorba más que ayuda. */
@media (max-width: 860px) {
  .ca-usuario { display: none; }

  /* En pantalla estrecha el centro absoluto se solaparía con Inicio y con el
     avatar: los destinos vuelven al flujo normal, pegados a Inicio. */
  .ca-nav-centro {
    position: static !important;
    transform: none !important;
    height: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;iFAEiF;;AAEjF,IAAI,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;;AAEnD,qBAAqB,cAAc,EAAE;;AAErC;mFACmF;AACnF;EACE,cAAc,aAAa,EAAE;;EAE7B;sEACoE;EACpE;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;AACF","sourcesContent":["/* Estilado propio del Centro de Aplicaciones.\n   El lenguaje visual común (fuente, animaciones fg-*, capa de densidad) vive en\n   `src/ui/estilos.css`, que se importa antes que este fichero desde index.jsx. */\n\n* { margin: 0; padding: 0; box-sizing: border-box; }\n\ninput::placeholder { color: #9aa4af; }\n\n/* En pantallas estrechas la barra superior se queda solo con el logotipo, los\n   destinos y el botón de salir: el bloque de nombre y rol estorba más que ayuda. */\n@media (max-width: 860px) {\n  .ca-usuario { display: none; }\n\n  /* En pantalla estrecha el centro absoluto se solaparía con Inicio y con el\n     avatar: los destinos vuelven al flujo normal, pegados a Inicio. */\n  .ca-nav-centro {\n    position: static !important;\n    transform: none !important;\n    height: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
